module.exports = __webpack_public_path__ + "static/media/volley.522919fc.png";